<template>
	<div ng-transclude="">
		<div ng-controller="buildingIndexCtrl" class="building buildingType19" ng-class="{buildingResourceProduction: building.data.buildingType <= 4}">
			<div ng-include="" src="pageTemplate">
				<div class="buildingDetails trainTroops" ng-controller="trainTroopsCtrl">
					<div ng-show="isBuildingBuild()">
						<div ng-controller="unitsTrainCtrl">
							<div ng-include="" src="'tpl/building/partials/lists/units.html'">
								<div class="contentBox gradient unitList">
									<div class="contentBoxBody">
										<carousel-unit-engineer :items="engineers" @on-active-item="(item) => activeItem = item" :cols="4" style="padding-top: 12px;" />
										<div v-if="activeItem">
											<table class="unitInfo transparent">
												<tbody>
													<tr>
														<td>
															<div class="unitHeader">
																<i class="unitIcon unitMedium gaul" :class="['unitType'+activeItem.type]" unit-icon="" big="true"></i>
																<h4 class="unitName">
																	<span><span>{{activeItem.name}}</span></span>
																	<span class="level" v-if="activeItem.unitLevel >= 0">
																		<span><span>&nbsp;Ур.</span></span> {{activeItem.unitLevel}}
																	</span>
																</h4>
																<div class="symbol_i_medium_wrapper">
																	<i class="symbol_i_medium_flat_white clickable" clickable="openWindow('help', {'pageId': 'Troops_' + activeItem.unitType})" content="Дополнительная информация" v-tippy="{placement: 'top'}" tooltip-translate="Units.Tooltip.UnitInfo" tooltip-placement="above"></i>
																</div>
															</div>
															<div class="description"><span>{{activeItem.description}}</span></div>
														</td>
														<td>
															<table class="unitAttributes transparent">
																<tbody>
																	<tr>
																		<td>
																			<i class="unit_capacity_small_flat_black" content="Могут переносить" v-tippy="{placement: 'bottom'}" tooltip-translate="Troops.CarryingCapacity.Label"></i>
																		</td>
																		<td>{{activeItem.capacity}}</td>
																	</tr>
																	<tr>
																		<td><i class="unit_speed_small_flat_black" content="Скорость" v-tippy="{placement: 'bottom'}" tooltip-translate="Troops.Speed.Label"></i></td>
																		<td>{{activeItem.speed}}</td>
																	</tr>
																	<tr>
																		<td>
																			<i class="unit_consumption_small_flat_black" content="Потребление" v-tippy="{placement: 'bottom'}" tooltip-translate="Troops.CropConsumption.Label"></i>
																		</td>
																		<td>{{activeItem.cropConsumption}}</td>
																	</tr>
																</tbody>
															</table>
														</td>
														<td>
															<table class="unitAttributes transparent" ng-if="building.data.buildingType != buildingTypes.BLACKSMITH">
																<tbody>
																	<tr>
																		<td><i class="movement_attack_small_flat_black" content="Атака" v-tippy="{placement: 'bottom'}" tooltip-translate="TroopAttribute.Attack"></i>
																		</td>
																		<td>{{activeItem.attack}}</td>
																	</tr>
																	<tr>
																		<td>
																			<i class="unit_defenseInfantry_small_flat_black" content="Защита от пехоты" v-tippy="{placement: 'bottom'}" tooltip-translate="TroopAttribute.DefenseInfantry"></i>
																		</td>
																		<td>{{activeItem.defenseInfantry}}</td>
																	</tr>
																	<tr>
																		<td>
																			<i class="unit_defenseCavalry_small_flat_black" content="Защита от кавалерии" v-tippy="{placement: 'bottom'}" tooltip-translate="TroopAttribute.DefenseCavalry"></i>
																		</td>
																		<td>{{activeItem.defenseCavalry}}</td>
																	</tr>
																</tbody>
															</table>
														</td>
													</tr>
												</tbody>
											</table>
											<div class="horizontalLine"></div>
											<display-resources v-if="activeItem" class="costsFooter" :resources="allCosts" :hide-zero="true" available="storage" :consumption="allConsumption" :time="activeItem.duration * activeItem.value" />
											<div class="sliderRow">
												<div class="sliderArrow"></div>
												<range-slider v-if="activeItem.maxAvailable <= 0" :min="1" :max="1" v-model.number="activeItem.value" disabled style="width: 87%;" />
												<range-slider v-if="activeItem.maxAvailable > 0" :min="1" :max="activeItem.maxAvailable" v-model.number="activeItem.value" style="width: 87%;" />
												<npc-trader-button type="unitTrain" :costs="allCosts" :current-max="0" :current-limit="0" />
											</div>
										</div>
									</div>
								</div>
							</div>
							
							<!-- unit not researched -->
							<button :class="{'disabled': !activeItem || activeItem.disabled || activeItem.maxAvailable == 0}" class="animate footerButton clickable" clickable="startTraining(activeItem)" content="Недостаточно ресурсов" v-tippy="{placement: 'top'}" play-on-click="12">
								<div class="content">
									<span class="innerText">
										<span><span>Обучить</span></span>
									</span>
									<!-- ngIf: price > 0 || forceGoldUsage -->
									<!-- ngIf: price == -1 && !forceGoldUsage -->
									<div class="animationOverlay"></div>
									<i class="checkmark action_check_small_flat_white"></i>
									<i class="checkmark action_check_small_flat_black"></i>
									<i class="checkmark action_check_small_flat_red"></i>
								</div>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

import CarouselUnitEngineer from '@/components/elements/CarouselUnitEngineer';
import DisplayResources from '@/components/elements/DisplayResources';
import NpcTraderButton from '@/components/elements/NpcTraderButton';
import RangeSlider from '@/components/elements/RangeSlider';

export default {
	mixins: lib.mixins,
	data: () => ({
		engineers: [
			{
				id: 1,
				type: 9,
				name: 'Лесоруб',
				description: 'Дает +20% к добыче дерева.',
				disabled: false,
				queue: {
					key: 0,
					count: 0,
					pause: 0,
				},
				costs: [
					940,
					540,
					360,
					0,
				],
				value: 1,
				unitLevel: 7,
				capacity: 0,
				speed: 17,
				cropConsumption: 2,
				attack: 0,
				defenseInfantry: 20,
				defenseCavalry: 10,
				duration: 403,
				time: 1723643172,
				maxAvailable: 10,
			},
			{
				id: 2,
				type: 9,
				name: 'Добытчик глины',
				description: 'Дает +20% к добыче глины.',
				disabled: false,
				queue: {
					key: 0,
					count: 0,
					pause: 0,
				},
				costs: [
					940,
					540,
					360,
					0,
				],
				value: 1,
				unitLevel: 7,
				capacity: 0,
				speed: 17,
				cropConsumption: 2,
				attack: 0,
				defenseInfantry: 20,
				defenseCavalry: 10,
				duration: 403,
				time: 1723643172,
				maxAvailable: 10,
			},
			{
				id: 3,
				type: 9,
				name: 'Каменщик',
				description: 'Дает +20% к добыче камня.',
				disabled: false,
				queue: {
					key: 0,
					count: 0,
					pause: 0,
				},
				costs: [
					940,
					540,
					360,
					0,
				],
				value: 1,
				unitLevel: 7,
				capacity: 0,
				speed: 17,
				cropConsumption: 2,
				attack: 0,
				defenseInfantry: 20,
				defenseCavalry: 10,
				duration: 403,
				time: 1723643172,
				maxAvailable: 10,
			},
			{
				id: 4,
				type: 9,
				name: 'Шахтер',
				description: 'Дает +20% к добыче железа.',
				disabled: false,
				queue: {
					key: 0,
					count: 0,
					pause: 0,
				},
				costs: [
					940,
					540,
					360,
					0,
				],
				value: 1,
				unitLevel: 7,
				capacity: 0,
				speed: 17,
				cropConsumption: 2,
				attack: 0,
				defenseInfantry: 20,
				defenseCavalry: 10,
				duration: 403,
				time: 1723643172,
				maxAvailable: 10,
			},
			{
				id: 5,
				type: 9,
				name: 'Фермер',
				description: 'Дает +20% к добыче зерна.',
				disabled: false,
				queue: {
					key: 0,
					count: 0,
					pause: 0,
				},
				costs: [
					940,
					540,
					360,
					0,
				],
				value: 1,
				unitLevel: 7,
				capacity: 0,
				speed: 17,
				cropConsumption: 2,
				attack: 0,
				defenseInfantry: 20,
				defenseCavalry: 10,
				duration: 403,
				time: 1723643172,
				maxAvailable: 10,
			},
			{
				id: 6,
				type: 9,
				name: 'Боцман',
				description: 'Дает -30% от времени плавания кораблей.',
				disabled: false,
				queue: {
					key: 0,
					count: 0,
					pause: 0,
				},
				costs: [
					940,
					540,
					360,
					0,
				],
				value: 1,
				unitLevel: 7,
				capacity: 0,
				speed: 17,
				cropConsumption: 2,
				attack: 0,
				defenseInfantry: 20,
				defenseCavalry: 10,
				duration: 403,
				time: 1723643172,
				maxAvailable: 10,
			},
		],
		
		activeItem: null,
	}),
	computed: {
		allCosts(){
			let unitsCosts = [];
			if(this.activeItem){
				for(let [index, value] of Object.entries(this.activeItem.costs)){
					unitsCosts[index] = value * this.activeItem.value;
				}
			}
			return unitsCosts;
		},
		allConsumption(){
			if(this.activeItem){
				return this.activeItem.cropConsumption * this.activeItem.value;
			}
			return 0;
		},
	},
	methods: {},
	components: {
		CarouselUnitEngineer,
		DisplayResources,
		NpcTraderButton,
		RangeSlider,
	},
}
</script>